import { useGlobalStore } from '../store'

import bindActions from '../store/bindActions'
import { LoginReducer, LoginSliceType } from '../store/login'
import { Fn } from 'depoto-core'

const { actions } = LoginReducer

type LoginHookReturnType = LoginSliceType & {
  handleLogin: Fn
  handleLogout: Fn
  handleAuthInit: Fn
  handleExternalLogin: Fn
}
export const useLogin = (): LoginHookReturnType => {
  const { state, dispatch } = useGlobalStore()
  const { login } = state
  const { handleLogin, handleLogout, handleAuthInit, handleExternalLogin } = actions
  const loginActions = bindActions(
    {
      handleLogin,
      handleLogout,
      handleAuthInit,
      handleExternalLogin,
    },
    dispatch,
  )

  return { ...login, ...loginActions }
}
